module.exports = __webpack_public_path__ + "media/images/sp/plans/mv_nightview-3a03d2d30b40e7a737e8a8dfdde3b5f4.webp";